import React from 'react';
import { MOCK_BOOTHS } from '../constants';
import { IssueType } from '../types';

// Mock Component for Beneficiary Mapping since we don't have real map capabilities
const BeneficiaryMap: React.FC = () => {
  return (
    <div className="p-6 bg-slate-50 min-h-screen">
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-slate-800">Labharthi Sampark (Beneficiary Mapping)</h2>
        <p className="text-sm text-slate-500">Track Orunodoi and PMAY saturation by region.</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* Visual Map Placeholder */}
        <div className="lg:col-span-2 bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden relative min-h-[400px]">
           <img 
            src="https://picsum.photos/800/600" 
            alt="Constituency Map" 
            className="w-full h-full object-cover opacity-80"
           />
           <div className="absolute top-4 right-4 bg-white/90 backdrop-blur p-4 rounded-lg shadow border border-slate-100">
              <h4 className="font-bold text-xs uppercase text-slate-500 mb-2">Scheme Saturation</h4>
              <div className="flex items-center gap-2 mb-1">
                <div className="w-3 h-3 rounded-full bg-green-500"></div>
                <span className="text-xs font-medium">High (&gt;80%)</span>
              </div>
              <div className="flex items-center gap-2 mb-1">
                <div className="w-3 h-3 rounded-full bg-yellow-500"></div>
                <span className="text-xs font-medium">Medium (50-80%)</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-3 h-3 rounded-full bg-red-500"></div>
                <span className="text-xs font-medium">Low (&lt;50%)</span>
              </div>
           </div>
        </div>

        {/* List of Action Items */}
        <div className="space-y-4">
           <div className="bg-white p-4 rounded-xl shadow-sm border-l-4 border-bjp-green">
              <h3 className="font-bold text-slate-800">Orunodoi 3.0 Targets</h3>
              <div className="mt-3 space-y-3">
                 {MOCK_BOOTHS.filter(b => b.keyIssues.includes(IssueType.ORUNODOI)).map(booth => (
                   <div key={booth.id} className="flex justify-between items-center text-sm border-b border-slate-50 pb-2">
                      <span className="text-slate-600 truncate w-32">{booth.name}</span>
                      <span className="text-xs px-2 py-1 bg-red-50 text-red-600 rounded">Gap Detected</span>
                   </div>
                 ))}
              </div>
              <button className="w-full mt-4 py-2 text-sm text-bjp-green font-medium bg-green-50 rounded hover:bg-green-100">
                Download Beneficiary List
              </button>
           </div>

           <div className="bg-white p-4 rounded-xl shadow-sm border-l-4 border-blue-500">
              <h3 className="font-bold text-slate-800">PMAY (Urban/Rural) Status</h3>
              <p className="text-sm text-slate-500 mt-1">Focus on Char areas for erosion victims.</p>
              <div className="mt-4">
                 <div className="flex justify-between text-xs mb-1">
                    <span>Sanctioned</span>
                    <span className="font-bold">1,240</span>
                 </div>
                 <div className="w-full bg-slate-100 h-2 rounded-full mb-3">
                    <div className="bg-blue-600 h-2 rounded-full" style={{ width: '65%' }}></div>
                 </div>
                 <div className="flex justify-between text-xs mb-1">
                    <span>Under Construction</span>
                    <span className="font-bold">850</span>
                 </div>
                 <div className="w-full bg-slate-100 h-2 rounded-full">
                    <div className="bg-blue-400 h-2 rounded-full" style={{ width: '40%' }}></div>
                 </div>
              </div>
           </div>
        </div>
      </div>
    </div>
  );
};

export default BeneficiaryMap;